import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import { ThemeProvider } from './components/ThemeProvider';
import Home from './pages/Home';
import About from './pages/About';
import AI from './pages/AI';
import Blog from './pages/Blog';
import Work from './pages/Work';
import UXFolio from './pages/UXFolio';
import WebsiteFolio from './pages/WebsiteFolio';
import Illustration from './pages/Illustration';
import AIArt from './pages/AIArt';
import StyleGuide from './pages/StyleGuide';
import ProjectDetail from './pages/ProjectDetail';
import WebsiteDetail from './pages/WebsiteDetail';
import JournalDetail from './pages/JournalDetail';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/index" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/ai" element={<AI />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<JournalDetail />} />
            <Route path="/work" element={<Work />} />
            <Route path="/work/:slug" element={<ProjectDetail />} />
            <Route path="/ux-folio" element={<UXFolio />} />
            <Route path="/work/:slug" element={<ProjectDetail />} />
            <Route path="/website-folio" element={<WebsiteFolio />} />
            <Route path="/website/:slug" element={<WebsiteDetail />} />
            <Route path="/illustration" element={<Illustration />} />
            <Route path="/ai-art" element={<AIArt />} />
            <Route path="/style-guide" element={<StyleGuide />} />
          </Routes>
        </Layout>
          <Toaster richColors position="bottom-right" />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;